import React from "react";
import { classNames } from "src/helpers/classNames";

export default function TRBody({ className = "", children }) {
  return <td className={classNames("break-all py-4 px-4 sm:pl-6 sm:py-3 text-sm text-gray-500", className)}>{children}</td>;
}
